<template>
    <div>
        <input type="file" ref="picture" accept="image/*" @change="onTakePictures" capture="camera" style="display: none;">
        <v-btn block color="primary" @click="takePicture"> <i class="material-icons"> photo_camera </i> </v-btn>
    </div>
</template>
<script>
export default {
    props: {
        maxFiles: {
            type: Number,
            default: -1
        },
        maxWidth: {
            type: Number,
            default: 800
        }
    },
    data: () => ({
        pictures: []
    }),
    methods: {
        takePicture() {
            if(this.maxFiles != -1 && this.pictures.length >= this.maxFiles) return toastr.error(`Máximo ${this.maxFiles} fotos`);

            this.$refs.picture.click();
        },
        onTakePictures(e) {
            const file = e.target.files[0];

            const myImg = new Image();

            myImg.addEventListener('load', e => {
                const img = this.resizeImage(e.target);
                this.pictures.push(img);
                this.$emit('input', this.pictures);
            });

            const fr = new FileReader();
            fr.addEventListener('load', e => {
                myImg.src = e.target.result;
            });
            fr.readAsDataURL(file);
        },
        resizeImage(img) {
            const MAX_WIDTH = this.maxWidth;

            if(img.width <= MAX_WIDTH) return img.src;

            const w = img.width;
            const h = img.height;

            const ratio = w/h;

            const nW = MAX_WIDTH;
            const nH = h * ratio;

            const canvas = document.createElement('canvas');
            canvas.width = nW;
            canvas.height = nH;

            const context = canvas.getContext('2d');

            context.drawImage(img, 0, 0, nW, nH);

            const imageData = canvas.toDataURL('image/png');

            return imageData;
        }
    }
}
</script>